<p-overlayPanel #fieldsPanel>
  <ng-template pTemplate="content">
    <div class="max-h-[17rem] w-[200px] overflow-y-auto">
      <div class="flex flex-col">

        <!-- Metadata Toggle -->
        <div class="mb-3 pb-3 border-b">
          <div class="flex items-center text-base text-[#848488] font-light">
            <div class="pr-2 py-1">
              <p-checkbox
                [binary]="true"
                [ngModel]="showMetadata()"
                (ngModelChange)="showMetadataChange.emit($event)">
              </p-checkbox>
            </div>
            <label class="cursor-pointer flex-grow pt-[3px]" (click)="showMetadataChange.emit(!showMetadata())">
              Metadaten anzeigen
            </label>
          </div>
        </div>

        <!-- Aktive Felder Section -->
        <div class="border-b mb-2">
          <div class="text-base font-medium leading-3r">Aktive Felder</div>
          <ul nxReorderList (nxReorder)="onFieldReordered($event)">
            <li
              nxReorderItem
              class="displayedColumn flex flex-row text-base text-[#848488] font-light leading-3"
              *ngFor="let field of displayedFields()">
              <div class="pr-2 py-1">
                <p-checkbox
                  [disabled]="!canRemoveFields()"
                  [binary]="true"
                  (click)="canRemoveFields() ? onRemoveField($event, field) : null"
                  [ngModel]="true">
                </p-checkbox>
              </div>
              <div class="pt-[3px] flex-grow">
                {{ getFieldLabel(field) }}
              </div>
              <div nxReorderHandle class="pr-2 py-1 cursor-grabbing">
                <i [ngClass]="'icon-expand'"></i>
              </div>
            </li>
          </ul>
        </div>

        <!-- Verfügbare Felder Section -->
        <div class="border-b mb-2">
          <div class="text-base justify-center items-center font-medium leading-3r">Verfügbare Felder</div>
          <ul class="text-base text-[#848488] font-light leading-3">
            <li *ngFor="let field of hiddenFields()" class="flex flex-row">
              <div class="pr-2 flex">
                <input type="checkbox" [checked]="false" (change)="onAddField(field)">
              </div>
              <div class="py-1 flex-grow">
                {{ getFieldLabel(field) }}
              </div>
              <div></div>
            </li>
          </ul>
          <ng-container *ngIf="!hiddenFields() || hiddenFields()?.length === 0">
            <div class="text-base text-[#848488] font-light">-</div>
          </ng-container>
        </div>

        <!-- Reset Button -->
        <nx-default-button
          (click)="onResetFields()"
          [width]="'full'"
          class="w-full"
          [style]="'dark'"
          [label]="'Felder zurücksetzen'">
        </nx-default-button>
      </div>
    </div>
  </ng-template>
</p-overlayPanel>

<nx-default-button
  (click)="fieldsPanel.toggle($event)"
  [style]="'dark'"
  [icon]="'icon-settings'">
</nx-default-button>
